// RevenueKeeper.js
'use strict';
import { connect } from 'react-redux';

import RevenueKeeper from '../component/RevenueKeeper.jsx';
import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';

const mapStateToProps = (state, { enabled }) => {
  return {
    enabled: enabled && !!getMeData(state, 'id'),
    hasFlixPlayed: getOperationData(state, ['player'], 'hasFlixPlayed'),
  };
};

export default connect(mapStateToProps)(RevenueKeeper);
